// extracted by css-extract-rspack-plugin
export default {"cls1":"CurrentPaperRow-cls1_bSg","cls2":"CurrentPaperRow-cls2_OzP CurrentPaperRow-cls1_bSg"};